import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({
  color = '#495057',
  size = 30,
  caption = 'Loading the data...',
  minLoadTime = 500,
  containerHeight = '200px'
}) => {
  // Convert size to Tailwind-compatible inline styles for dynamic sizing
  const spinnerSize = `${size}px`;
  const borderWidth = `${Math.max(size / 10, 3)}px`;
  const fontSize = `${Math.max(size / 3, 14)}px`;

  return (
    <div 
      className="flex justify-center items-center flex-col gap-4"
      style={{ minHeight: containerHeight }}
    >
      <style>
        {`
          @keyframes rotation {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <span 
        className="inline-block rounded-full box-border"
        style={{
          width: spinnerSize,
          height: spinnerSize,
          border: `${borderWidth} solid ${color}`,
          borderBottomColor: 'transparent',
          animation: 'rotation 1s linear infinite'
        }}
      />
     
        <div 
          className="text-center mt-5"
          style={{ color, fontSize }}
        >
          Loading...
        </div>
    </div>
  );
};

Loader.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  caption: PropTypes.string,
  minLoadTime: PropTypes.number,
  containerHeight: PropTypes.string
};

export default Loader;
